export default __webpack_public_path__ + "static/media/impedelife.4b87eddc.png";